module.exports = __webpack_public_path__ + "static/media/error-red-cross-logo.a02417ce.svg";